module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    ref: "permittable",
    attrs: {
      "table-ref": "permittable",
      "title": "Permits",
      "icon": "fa fa-clipboard",
      "url": '/permits/site/' + _vm.rowData.id + (this.telcoId ? '/org/' + this.telcoId : ''),
      "fields": _vm.fields,
      "add-action": _vm.isManager('project|maintenance|finance|property|admin') ? _vm.action : null,
      "add-props": _vm.addProps,
      "detail-component": "permits-detail-row"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('site-progress', {
    attrs: {
      "row-data": _vm.rowData
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-149f7316"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/SitePermits.vue
// module id = 1434
// module chunks = 0